import React, { useState, useEffect } from "react";
import "../styles/Section1.css";
import "../styles/Navbar.css";
import { useNavigate } from "react-router-dom";
import Container from "react-bootstrap/Container";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import CryptoJS from "crypto-js";
import { Modal, Button, Form } from "react-bootstrap";
import { FaEye, FaEyeSlash } from 'react-icons/fa';
import banner1 from '../images/bannerRe.png';
import banner2 from '../images/ban2.jpg';
import banner3 from '../images/ban4.jpg';
import { useLocation } from "react-router-dom";
import axios from "axios";

function Navbar1() {
  const [show, setShow] = useState(false);
  const [navbarBg, setNavbarBg] = useState("transparent");
  const [showModal, setShowModal] = useState(false);
  const [loginCode, setLoginCode] = useState("");
  const [error, setError] = useState("");
  const [showCode, setShowCode] = useState(false);
     const [currentImage, setCurrentImage] = useState(0);

const images = [banner1, banner2, banner3];

 const location = useLocation();


 const bannerContent = {
    "/": {
      heading: "Invest Smart Travel Far!",
      subheading: "Turn Your Investments into Opportunities for Luxury and Freedom.",
    },
    "/aboutus": {
      heading: "Driven by Vision, Powered by Expertise",
      subheading: "Learn how KPN Properties turns global investment goals into real-world success.",
    },
    "/portfolio": {
      heading: "Our Global Footprint, Your Investment Edge",
      subheading: "Explore a curated portfolio of properties that redefine luxury and returns.",
    },
    "/investment": {
      heading: "Empowering Investors with Global Opportunities",
      subheading: "Discover strategic pathways to financial growth through real estate investment.",
    },
  };


  const currentPath = location.pathname;
  const content = bannerContent[currentPath] || bannerContent["/"];




  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentImage(prev => (prev + 1) % images.length);
    }, 5000); // change every 5 seconds

    return () => clearInterval(interval);
  }, []);

  const navigate = useNavigate();

  // Background change on scroll
  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 50) {
        setNavbarBg("rgba(0, 0, 0, 0.8)");
      } else {
        setNavbarBg("transparent");
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);


  // useEffect(() => {
  //   const params = new URLSearchParams(window.location.search);
  //   const showLogin = params.get("showLogin");
  //   if (showLogin === "true") {
  //     setShowModal(true);
  //   }
  // }, []);


  const SECRET_KEY = "MySecretKey12345"; 

function decryptInvitationCode(encryptedCode) {
  // First decode from base64-url format to base64
  const base64 = encryptedCode.replace(/-/g, '+').replace(/_/g, '/');

  // Decode Base64 string into a WordArray
  const decodedBytes = CryptoJS.enc.Base64.parse(base64);

  // Decrypt using AES/ECB/PKCS5Padding
  const decrypted = CryptoJS.AES.decrypt(
    { ciphertext: decodedBytes },
    CryptoJS.enc.Utf8.parse(SECRET_KEY),
    {
      mode: CryptoJS.mode.ECB,
      padding: CryptoJS.pad.Pkcs7
    }
  );

  return decrypted.toString(CryptoJS.enc.Utf8);
}




  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const showLogin = params.get("showLogin");
    const invitationCode = params.get("invitationCode");
  
    // Helper to generate a 10-char random alphanumeric string
    const generateRandomCode = () => {
      const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
      let result = '';
      for (let i = 0; i < 10; i++) {
        result += chars.charAt(Math.floor(Math.random() * chars.length));
      }
      return result;
    };
  
    if (showLogin === "true") {
      setShowModal(true);
  
      if (invitationCode) {
        try {
          const decrypted = decryptInvitationCode(invitationCode); // from earlier function
          setLoginCode(decrypted);
        } catch (err) {
          console.error("Decryption failed:", err);
          // fallback: generate random code
          setLoginCode(generateRandomCode());
        }
      } else {
        // No invitationCode param? generate a random code
        setLoginCode(generateRandomCode());
      }
    }
  }, []);
  

  // Show/hide navbar
  useEffect(() => {
    const onScroll = () => {
      setShow(window.scrollY > 100);
    };

    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  // Navigation handlers
  function handleClick() {
    navigate("/portfolio");
  }

  function handleContact() {
    navigate("/", { state: { scrollToBottom: true } });
  }

  function handleInvestment() {
    navigate("/investment");
  }

  function handleClickHome() {
    navigate("/");
  }

  function handleClickAbout() {
    navigate("/aboutus");
  }

  const handleLoginClick = () => {
    const generateRandomCode = () => {
      const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
      let result = '';
      for (let i = 0; i < 10; i++) {
        result += chars.charAt(Math.floor(Math.random() * chars.length));
      }
      return result;
    };
  
    setLoginCode(generateRandomCode());
    setShowModal(true);
    setError("");
  };


  // const handleLoginClick = () => {
  //   setShowModal(true);
  //   setLoginCode("");
  //   setError("");
  // };

  const handleLoginSubmit = () => {
    if (!loginCode.trim()) {
      setError("Please enter a code.");
      return;
    }
  
    axios
      .post(`https://apiv1.worknotion.com/investorsProgram/validateCodes?code=${loginCode}`)
      .then((res) => {
        const { id } = res.data;
  
        if (!id) {
          setError("Invalid invitation code.");
          return;
        }
  
        sessionStorage.setItem("invitationCodeId", id);
        setShowModal(false);
        navigate("/login");
      })
      .catch((error) => {
        console.error("API error:", error);
        setError("Login failed. Please try again.");
      });
  };
  

  return (
    <>
      <Navbar
        expand="md"
        fixed="top"
        style={{
          backgroundColor: navbarBg,
          transition: "background-color 0.3s ease-in-out",
        }}
      >
        <Container>
          <Navbar.Brand href="#">
            <div className="d-flex">
              <img
                src={require("../images/kpn investments logo (2).png")}
                alt="success"
                style={{ height: "80px" }}
                onClick={handleClickHome}
              />
              <h1 className="text-white navtxt mt-4 ms-3">KPN Investments</h1>
            </div>
          </Navbar.Brand>

          <Navbar.Toggle aria-controls="navbarNav" />
          <Navbar.Collapse id="navbarNav" className="justify-content-end">
            <Nav>
              <Nav.Link
                onClick={handleClickHome}
                className="text-white pe-md-4 navtxt"
                href="#"
              >
                Home
              </Nav.Link>
              <Nav.Link
                onClick={handleClickAbout}
                className="text-white px-md-4 navtxt"
                href="#"
              >
                About
              </Nav.Link>
              <Nav.Link
                onClick={handleClick}
                className="text-white px-md-4 navtxt"
                href="#"
              >
                Portfolio
              </Nav.Link>
              <Nav.Link
                onClick={handleInvestment}
                className="text-white px-md-4 navtxt"
                href="#"
              >

Investment
              </Nav.Link>
              <Nav.Link
                onClick={handleContact}
                className="text-white px-md-4 navtxt"
                href="#"
              >

Contact Us
              </Nav.Link>
              <Nav.Link
                onClick={handleLoginClick}
                className="text-white px-md-4 navtxt"
                href="#"
              >
                Investor Input
              </Nav.Link>
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>

      <div  className="mainbanner"
      style={{
        backgroundImage: `linear-gradient(180deg, rgba(24, 24, 24, 0.3) 0%, rgba(48, 73, 136, 0.024) 100%), url(${images[currentImage]})`,
      }}>
        <div className="container">
          <div className="col-lg-9 mx-auto padmainbanner">
            <h1 className="headingmainbanner">{content.heading}</h1>
            <p className="subheadingmainbanner py-2 px-3 rounded">
              {content.subheading}
            </p>
          </div>
        </div>
      </div>

      {/* Login Code Modal */}
      <Modal show={showModal} onHide={() => setShowModal(false)} centered>
  <Modal.Header closeButton>
    <Modal.Title>Investor Input Questionnaire Form</Modal.Title>
  </Modal.Header>
  <Modal.Body>
    <Form>
      <Form.Group controlId="formCode">
        <Form.Label>Unique Code</Form.Label>
        <div className="position-relative">
          <Form.Control
            type={showCode ? 'text' : 'password'}
            placeholder="Enter code"
            value={loginCode}
            onChange={(e) => setLoginCode(e.target.value)}
          />
          <span
            onClick={() => setShowCode(!showCode)}
            style={{
              position: 'absolute',
              top: '50%',
              right: '10px',
              transform: 'translateY(-50%)',
              cursor: 'pointer',
              color: '#6c757d',
            }}
          >
            {showCode ? <FaEyeSlash /> : <FaEye />}
          </span>
        </div>
      </Form.Group>
      {error && <p className="text-danger mt-2">{error}</p>}
    </Form>
  </Modal.Body>
  <Modal.Footer>
    <Button variant="secondary" onClick={() => setShowModal(false)}>
      Cancel
    </Button>
    <Button variant="primary" onClick={handleLoginSubmit}>
      Continue
    </Button>
  </Modal.Footer>
</Modal>
    </>
  );
}

export default Navbar1;
